<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormNote class="mb-6"
          >Note: Kolom <strong>Asset</strong>, <strong>Member / ID</strong>,
          <strong>Member Bank</strong> dan <strong>Bank</strong> tidak dapat
          diubah ketika form sudah dibuat (walaupun status masih pending).
          Periksa lagi dengan teliti sebelum submit form!</FormNote
        >
        <FormRow class="mb-4" :required="true">
          <template #label>Asset</template>
          <template #field>
            <multiselect
              v-model="formData.asset"
              :options="listAsset"
              :loading="listAssetLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :class="$v.formData.asset.$error ? 'multiselect--error' : ''"
              :disabled="!formCreate && !placeholder"
              track-by="id"
              label="name"
              tag-placeholder="Press enter to choose"
              placeholder="Choose asset"
              :showLabels="false"
              @input="chooseAsset"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.asset.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.asset.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Member / ID</template>
          <template #field>
            <div v-if="formCreate">
              <multiselect
                v-model="formData.account"
                :options="listAccount"
                :loading="listAccountLoading"
                :close-on-select="true"
                :hide-selected="false"
                :allow-empty="false"
                :class="$v.formData.account.$error ? 'multiselect--error' : ''"
                track-by="id"
                label="tooltip"
                tag-placeholder="Press enter to choose"
                placeholder="Search member"
                :showLabels="false"
                :internal-search="false"
                :searchable="formCreate || placeholder"
                :disabled="!formCreate && !placeholder"
                @search-change="getListAccount"
                @input="chooseAccount"
              >
                <template #noOptions>
                  Search member
                  <template v-if="formData.asset">
                    in {{ formData.asset.name }}</template
                  ></template
                >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.account.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.account.required"
                  >This field is required.</span
                >
              </div>
            </div>
            <div v-else>
              <input
                class="bg-gray-400 bg-opacity-25 form__input"
                readonly
                disabled
                type="text"
                :value="formData.account.tooltip"
              />
            </div>
          </template>
          <template #help>
            <span v-if="formCreate"
              >Search by ID, username or member's bank account</span
            >
            <button
              type="button"
              class="button button--primary mt-2"
              v-if="formData.account"
              v-clipboard:copy="formData.account.panel_id"
            >
              Copy {{ formData.account.panel_id }}
            </button>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Member Bank</template>
          <template #field>
            <div v-if="formCreate">
              <multiselect
                v-model="formData.from_bank_account"
                :options="listMemberBank"
                :loading="listMemberBankLoading"
                :close-on-select="true"
                :hide-selected="false"
                :allow-empty="false"
                :class="
                  $v.formData.from_bank_account.$error
                    ? 'multiselect--error'
                    : ''
                "
                track-by="id"
                label="tooltip"
                tag-placeholder="Press enter to choose"
                placeholder="Choose member bank"
                :disabled="!formCreate && !placeholder"
                :deselectLabel="''"
                @input="chooseMemberBank"
              >
                <template #noOptions v-if="formData.account"
                  >Choose bank for {{ formData.account.name }}</template
                >
                <template #noOptions v-else
                  >Please select member first.</template
                >
                <template #noResult v-if="formData.account"
                  >No results found.</template
                >
                <template #noResult v-else
                  >Please select member first.</template
                >
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.from_bank_account.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.from_bank_account.required"
                  >This field is required.</span
                >
              </div>
            </div>
            <div v-else>
              <input
                class="bg-gray-400 bg-opacity-25 form__input"
                readonly
                disabled
                type="text"
                :value="
                  '(' +
                  formData.from_bank_account.bank.name +
                  ') ' +
                  formData.from_bank_account.holder +
                  ' - ' +
                  formData.from_bank_account.number
                "
              />
            </div>
          </template>
        </FormRow>

        <FormRow v-if="memberBankHistory.length > 0">
          <template #label></template>
          <template #field>
            <FormNote class="mb-6 text-sm"
              ><span class="mb-2 block"
                >Note: Member Bank yang terpilih
                <strong
                  >sudah dirubah sebanyak
                  {{ memberBankHistory.length }} kali</strong
                >:</span
              >
              <span
                class="block"
                v-for="log in memberBankHistory"
                :key="log.id"
              >
                {{ log.name }}
              </span></FormNote
            >
          </template>
        </FormRow>

        <FormRow
          class="mb-4"
          :required="true"
          v-if="formData.asset || placeholder"
        >
          <template #label>Bank</template>
          <template #field>
            <div v-if="formCreate">
              <multiselect
                :options="listBank"
                :loading="listBankLoading"
                :class="
                  $v.formData.to_bank_account.$error ? 'multiselect--error' : ''
                "
                track-by="id"
                label="name"
                :placeholder="'Search withdraw bank for ' + formData.asset.name"
                v-model="formData.to_bank_account"
                :allow-empty="false"
                :disabled="!formCreate && !placeholder"
                :deselectLabel="''"
                :internal-search="false"
                @search-change="getListBank"
                @input="chooseBank"
              >
                <template #noOptions
                  >Search withdraw bank for {{ formData.asset.name }}</template
                >
                <template #noResult>No results found.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.to_bank_account.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.to_bank_account.required"
                  >This field is required.</span
                >
              </div>
            </div>

            <div v-else>
              <input
                class="bg-gray-400 bg-opacity-25 form__input"
                readonly
                disabled
                type="text"
                :value="formData.to_bank_account.tooltip"
              />
            </div>
          </template>

          <template #help>
            <span
              >Only withdraw banks for {{ formData.asset.name }} will be
              shown</span
            >
            <span
              v-if="formData.bank"
              class="block text-base"
              :class="
                bankOverlimit ? 'text-red-500 font-medium' : 'text-green-500'
              "
              >Balance Status: {{ bankBalance }} /
              {{ bankLimit }}
              <span v-if="bankOverlimit" class="text-red"
                >(Overlimit!)</span
              ></span
            >
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Withdraw Amount</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.amount.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
              type="text"
              class="form__input"
              placeholder="Withdraw Amount"
              v-model="formData.amount"
              @blur="calculateBalance"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
            />
            <div
              class="form-error"
              v-if="$v.formData.amount.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.amount.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Winning Transfer</template>
          <template #field>
            <input
              :class="{
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
              type="text"
              class="form__input"
              placeholder="Winning Transfer"
              v-model="formData.bonus"
              @blur="calculateBalance"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
            />
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Withdraw Fee</template>
          <template #field>
            <input
              type="text"
              class="form__input"
              :class="{
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
              placeholder="Withdraw Fee"
              v-model="formData.fee"
              @blur="checkFee"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
            />
          </template>
        </FormRow>

        <FormRow class="mb-4" v-if="!formCreate">
          <template #label>Credit Balance</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.before_credit.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus != 0,
              }"
              type="text"
              class="form__input"
              placeholder="Current Credit Balance"
              v-model="formData.before_credit"
              :disabled="currentStatus != 0"
              :readonly="currentStatus != 0"
              @blur="calculateBalance"
            />
            <div
              class="form-error"
              v-if="$v.formData.before_credit.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.before_credit.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" v-if="!formCreate">
          <template #label>New Credit Balance</template>
          <template #field>
            <input
              readonly
              disabled
              type="text"
              class="form__input bg-gray-400 bg-opacity-25"
              placeholder="New Credit Balance"
              v-model="newCreditBalance"
            />
            <button
              type="button"
              class="button button--primary mt-2"
              v-if="formData.account"
              v-clipboard:copy="
                Math.floor(parseFloat(parseCurrency(newCreditBalance) / 1000))
              "
            >
              Copy
              {{
                Math.floor(parseFloat(parseCurrency(newCreditBalance) / 1000))
              }}
            </button>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true" v-if="currentStatus != 2">
          <template #label>Bank Transaction Date</template>
          <template #field>
            <date-picker
              v-model="formData.bank_date"
              type="datetime"
              :editable="false"
              :clearable="false"
              :show-seconds="false"
              input-class="form__input"
              value-type="YYYY-MM-DD HH:mm:ss"
              format="DD MMMM YYYY - HH:mm"
              time-title-format="DD MMM YYYY"
              placeholder="Bank Transaction Date / Time"
              :disabled-date="notAfterToday"
              :disabled-time="notAfterNow"
            ></date-picker>
            <div
              class="form-error"
              v-if="$v.formData.bank_date.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.bank_date.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Panel Date</template>
          <template #field>
            <date-picker
              v-model="formData.panel_date"
              type="datetime"
              :editable="false"
              :clearable="false"
              :show-seconds="false"
              input-class="form__input"
              value-type="YYYY-MM-DD HH:mm:ss"
              format="DD MMMM YYYY - HH:mm"
              time-title-format="DD MMM YYYY"
              placeholder="Panel Date / Time"
              :disabled-date="notAfterToday"
              :disabled-time="notAfterNow"
              :class="{
                'form__input--error':
                  $v.formData.panel_date.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
            ></date-picker>
            <div
              class="form-error"
              v-if="$v.formData.panel_date.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.panel_date.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Ticket Number</template>
          <template #field>
            <input
              type="text"
              class="form__input"
              v-model="formData.ticket_number"
              placeholder="Ticket Number"
              :class="{
                'bg-gray-400 bg-opacity-25': currentStatus == 2 || currentStatus == 1,
              }"
              :readonly="currentStatus == 2 || currentStatus == 1"
              :disabled="currentStatus == 2 || currentStatus == 1"
            />
          </template>
          <template #help>
            For Nexus transactions, please input the ticket number.
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Note</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Note"
              rows="5"
              v-model="formData.note"
              :class="{
                'bg-gray-400 bg-opacity-25': currentStatus == 2,
              }"
              :readonly="currentStatus == 2"
              :disabled="currentStatus == 2"
            ></textarea>
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Last Withdraw Information</template>
          <template #field>
            <div
              class="
                border-gray-300 border border-solid
                py-2
                px-3
                bg-gray-400 bg-opacity-25
              "
              v-if="lastDepositData"
            >
              <table class="last-deposit-table w-full table-fixed text-sm">
                <tbody>
                  <tr>
                    <td>Panel Date</td>
                    <td>
                      {{
                        dateformat(lastDepositData.date, "DD MMMM YYYY - HH:mm")
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Bank Transaction Date</td>
                    <td>
                      {{
                        dateformat(
                          lastDepositData.bank_transaction.date,
                          "DD MMMM YYYY - HH:mm"
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Panel ID</td>
                    <td>{{ lastDepositData.account.panel_id }}</td>
                  </tr>
                  <tr>
                    <td>Withdraw Amount</td>
                    <td>
                      {{ lastDepositData.amount }}
                    </td>
                  </tr>
                  <tr>
                    <td>Credit Balance</td>
                    <td>
                      {{ lastDepositData.before_credit }}
                    </td>
                  </tr>
                  <tr>
                    <td>New Credit Balance</td>
                    <td>
                      {{ lastDepositData.after_credit }}
                    </td>
                  </tr>
                  <tr>
                    <td>Bank</td>
                    <td>
                      {{ lastDepositData.to_bank_account.tooltip }}
                    </td>
                  </tr>
                  <!-- <tr>
                    <td>Current Bank Balance</td>
                    <td>
                      {{ lastDepositData.bank_account.balance.amount }}
                    </td>
                  </tr> -->
                </tbody>
              </table>
            </div>
            <input
              v-else
              type="text"
              class="form__input form__input--readonly"
              disabled
              value="-"
            />
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="!formCreate && currentStatus == 0">
          <template #label>Status</template>
          <template #field>
            <div class="flex">
              <button
                v-if="formCreate"
                class="
                  border-gray-600
                  button
                  border border-solid
                  hover:bg-gray-600
                  hover:text-white
                  transition-all
                  mr-2
                  duration-200
                  text-left
                "
                :class="
                  !formData.status || formData.status == '0'
                    ? 'bg-gray-600 text-white'
                    : 'text-gray-600'
                "
                type="button"
                @click="setStatus(0)"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'question-circle']" />
                  Pending</span
                >
              </button>
              <button
                v-if="currentStatus != 2 && userCan('update.withdraw')"
                class="
                  border-green-500
                  button
                  border border-solid
                  hover:bg-green-500
                  hover:text-white
                  transition-all
                  duration-200
                  mr-2
                  text-left
                "
                :class="
                  formData.status == '1'
                    ? 'bg-green-500 text-white'
                    : 'text-green-500'
                "
                @click="setStatus(1)"
                type="button"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'check-circle']" />
                  Approve</span
                >
              </button>
              <button
                v-if="!formCreate && userCan('delete.withdraw')"
                class="
                  border-red-500
                  button
                  border border-solid
                  hover:bg-red-500
                  hover:text-white
                  transition-all
                  duration-200
                  text-left
                "
                :class="
                  formData.status == '2'
                    ? 'bg-red-500 text-white'
                    : 'text-red-500'
                "
                @click="setStatus(2)"
                type="button"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'times-circle']" />
                  Reject</span
                >
              </button>
            </div>
            <div
              class="form-error"
              v-if="$v.formData.status.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.status.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormDataLog :data="formData" v-if="!formCreate" />
      </template>

      <template #footer>
        <FormNote class="mb-6"
          >Note: Kolom <strong>Asset</strong>, <strong>Member / ID</strong>,
          <strong>Member Bank</strong> dan <strong>Bank</strong> tidak dapat
          diubah ketika form sudah dibuat (walaupun status masih pending).
          Periksa lagi dengan teliti sebelum submit form!</FormNote
        >
        <FormRow class="mb-0">
          <template
            #field
            v-if="
              currentStatus != 2 &&
              (userCan('create.withdraw') ||
                userCan('update.withdraw') ||
                userCan('delete.withdraw'))
            "
          >
            <BaseButton class="mr-2" type="submit">Submit</BaseButton>
          </template>
          <template #link>
            <div>
              <template v-if="currentStatus != 2">or</template>
              <router-link
                :to="{ name: 'WithdrawList' }"
                class="link"
                :class="{
                  'ml-2': currentStatus != 2,
                }"
                >Back to List Withdraw</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>

    <!-- <CardBase v-if="!formCreate && formReady" class="mt-10">
      <template #header>Changelog</template>
      <template #content>
        <table class="w-full table-fixed">
          <thead v-if="!listLogsLoading">
            <tr>
              <th class="w-2/12">Date / Time</th>
              <th class="w-2/12">User</th>
              <th class="w-2/12">Action</th>
              <th class="text-left">Changes</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="table__loader" colspan="4" v-if="listLogsLoading">
                Please wait
                <font-awesome-icon
                  :icon="['fas', 'spinner']"
                  spin
                  class="ml-2"
                />
              </td>
            </tr>
            <tr v-if="listLogs.length <= 0 && !listLogsLoading">
              <td class="text-center pt-6" colspan="4">No data found.</td>
            </tr>
            <tr v-for="row in listLogs" :key="row.id">
              <td>{{ row.created_at }}</td>
              <td>{{ row.created_by.name }}</td>
              <td>{{ row.action }}</td>
              <td>
                <pre
                  v-if="row.changes"
                  class="text-left"
                  v-html="printJson(row.changes)"
                ></pre>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </CardBase> -->
  </form>
</template>

<script>
import { datePickerMixin } from "@/mixins/datePickerMixin";
import { CurrencyDirective, parse } from "vue-currency-input";
import { required, requiredIf } from "vuelidate/lib/validators";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";
import { submitFormMixin } from "@/mixins/submitFormMixin";
import { getListBankOptionsMixin } from "@/mixins/getListBankOptionsMixin";

import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";

const prettyPrintJson = require("pretty-print-json");

export default {
  directives: {
    currency: CurrencyDirective,
  },
  mixins: [
    getListAssetMixin,
    submitFormMixin,
    getListBankOptionsMixin,
    datePickerMixin,
  ],
  components: {
    Multiselect,
    DatePicker,
  },
  data: () => {
    return {
      memberBankHistory: [],
      placeholder: false,
      listAsset: [],
      listAssetLoading: false,
      listAccount: [],
      listAccountLoading: false,
      listMemberBank: [],
      listMemberBankLoading: false,

      listBank: [],
      listBankLoading: false,

      listLogs: [],
      listLogsLoading: true,

      fileTransactionProof: null,
      fileTransactionProofError: false,

      proofIndex: null,
      proofItems: [],

      currentStatus: "",

      formData: {
        asset: null,
        bank_category: {
          id: 1,
          name: "Sortir",
        },
        from_bank_account: null,
        note: null,
        account: null,
        proof: null,
        status: 0,
        to_bank_account: null,
        before_credit: 0,
        fee: 0,
        panel_date: null,
        bank_date: null,
      },

      lastDepositData: null,
      bankLimit: 0,
      bankBalance: 0,
      bankOverlimit: false,
      newCreditBalance: 0,
    };
  },
  validations: {
    formData: {
      asset: {
        required,
      },
      account: {
        required,
      },
      from_bank_account: {
        required,
      },
      to_bank_account: {
        required,
      },
      amount: {
        required,
      },
      bank_date: {
        required,
      },
      panel_date: {
        required,
      },
      before_credit: {
        required: requiredIf(function () {
          return !this.formCreate;
        }),
      },
      status: {
        required,
      },
    },
  },
  watch: {
    $route(to) {
      if (to.name == "WithdrawCreate") {
        this.formCreate = true;
        this.formData = {
          asset: null,
          bank_category: {
            id: 1,
            name: "Sortir",
          },
          from_bank_account: null,
          note: null,
          account: null,
          proof: null,
          status: 0,
          to_bank_account: null,
          before_credit: 0,
          fee: 0,
          panel_date: this.dateformat(new Date()),
          bank_date: this.dateformat(new Date()),
        };
        this.lastDepositData = null;
      } else if (to.name == "WithdrawEdit") {
        this.formData.id = this.$route.params.id;
        this.formCreate = false;
        this.fetchData();
      }
    },
  },
  computed: {
    submitUrl() {
      return this.formCreate
        ? "/" + this.$route.meta.endpoint
        : "/" + this.$route.meta.endpoint + "/" + this.formData.id;
    },
    fetchEndPoint() {
      return this.$route.meta.endpoint;
    },
  },
  created() {
    if (this.formCreate || !this.formData.asset) {
      this.listAssetLoading = true;
    }

    this.$_debounceTimer = null;

    this.formData.bank_date = this.dateformat(new Date());
    this.formData.panel_date = this.dateformat(new Date());

    if (this.formCreate) {
      this.getListAsset();
      this.getListBankCategory();
      this.formData.status = 0;
      this.formData.bonus = 0;

      if (this.$route.params.accountId) {
        this.listAccountLoading = true;

        this.$http
          .get(
            process.env.VUE_APP_API_URL +
              "/member-account?uuid=" +
              this.$route.params.accountId
          )
          .then((res) => {
            if (res.status == 200) {
              const response = res.data;

              if (response) {
                this.listAccount = response.data;

                this.formData.account = response.data[0];
                this.formData.asset = response.data[0].asset;
                this.chooseAccount(response.data[0]);
                this.setStatus(1);
              }
            }
          })
          .finally(() => {
            this.listAccountLoading = false;
          });
      }
    } else {
      this.listAssetLoading = false;
      // this.getListLogs();
    }
  },
  methods: {
    parseCurrency(data) {
      return parse(data);
    },
    checkFee() {
      if (!this.formData.fee) this.formData.fee = 0;
    },
    chooseMemberBank(selectedOption) {
      console.log("chosen");
      this.formData.from_bank_account_account_id = selectedOption.id;

      this.memberBankHistory = selectedOption.history;
    },
    getLastWithdraw(memberUuid) {
      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            "/member/" +
            memberUuid +
            "/last-withdraw"
        )
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.lastDepositData = response.data;
            }
          }
        })
        .finally(() => {
          this.listMemberBankLoading = false;
        });
    },
    chooseAsset() {
      this.clearListAccount();
      this.clearListMemberBank();

      if (this.formCreate) {
        // If it's on create deposit form, when we change asset,
        // We clear out the list of banks
        this.clearListBank();
        // this.getListBank();
      }
    },
    calculateBalance() {
      if (!this.formData.amount) this.formData.amount = 0;
      if (!this.formData.before_credit) this.formData.before_credit = 0;
      if (!this.formData.bonus) this.formData.bonus = 0;

      // console.log(this.formData.amount, this.formData.before_credit)

      const amount = parse(this.formData.amount);
      const before_credit = parse(this.formData.before_credit);
      const bonus = parse(this.formData.bonus);

      if (isNaN(amount) || isNaN(before_credit)) {
        this.newCreditBalance = "Error";
      } else {
        this.newCreditBalance = Intl.NumberFormat("en", {
          minimumFractionDigits: 2,
        }).format(before_credit + bonus - amount);
      }
    },
    clearListAccount() {
      this.listAccount = [];
      this.formData.account = null;
    },
    clearListMemberBank() {
      this.listMemberBank = [];
      this.formData.from_bank_account = null;
    },
    clearListBank() {
      if (!this.formCreate && !this.placeholder) {
        this.formData.before_credit = this.formData.account.balance;
      }

      this.listBank = [];
      this.formData.to_bank_account = null;
    },
    chooseAccount(selectedOption) {
      this.getListMemberBank(selectedOption.member.uuid);

      if (!this.formData.asset) {
        this.formData.asset = selectedOption.asset;
      }

      // if (!this.formData.asset) {
      // this.formData.asset = selectedOption.asset;
      this.clearListBank();
      // this.getListBank();
      // }

      if (!this.formCreate && this.placeholder) {
        this.formData.before_credit = this.formData.account.balance;
        this.calculateBalance();
      }

      // console.log("choose");
      this.getLastWithdraw(selectedOption.member.uuid);
    },
    chooseBankCategory() {
      // If we are changing bank category, we have to clear list bank
      this.clearListBank();

      // Then we get a new list of banks
      // this.getListBank();
    },
    chooseBank(selectedOption) {
      this.bankLimit = selectedOption.limit_daily;
      this.bankBalance = selectedOption.balance;

      if (parse(this.bankBalance) > parse(this.bankLimit)) {
        this.bankOverlimit = true;
      } else {
        this.bankOverlimit = false;
      }
    },
    getListMemberBank(memberId, selected = "") {
      this.listMemberBank = [];
      this.formData.from_bank_account = null;
      this.listMemberBankLoading = true;
      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/member/" + memberId + "/bank-account"
        )
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listMemberBank = response.data;

              if (selected) {
                this.formData.from_bank_account = selected;
              } else {
                if (this.listMemberBank.length == 1)
                  this.formData.from_bank_account = this.listMemberBank[0];
                this.memberBankHistory = this.listMemberBank[0].history;
              }
            }
          }
        })
        .finally(() => {
          this.listMemberBankLoading = false;
        });
    },
    getListBank(query) {
      const assetId = this.formData.asset ? this.formData.asset.id : null;

      // If there's asset ID or if this is a placeholder, we get the list of bank
      if (assetId || this.placeholder) {
        // const assetParam = assetId ? "&asset_id=" + assetId : "";

        if (query.length >= 3) {
          this.listBankLoading = true;

          this.debounce(() => {
            this.$http
              .get(
                process.env.VUE_APP_API_URL +
                  "/bank-account?bank_type_id=2,5&status=1" +
                  "&search=" +
                  query
              )
              .then((res) => {
                if (res.status == 200) {
                  const response = res.data;

                  if (response) {
                    this.listBank = response.data;

                    // if (bankId) {
                    //   this.chooseBank(bankId);
                    // }
                  }
                }
              })
              .finally(() => {
                this.listBankLoading = false;
              });
          }, 500);
        }
      }
    },
    printJson(data) {
      return data ? prettyPrintJson.toHtml(JSON.parse(data)) : "-";
    },
    getListLogs() {
      this.$http
        .get(
          process.env.VUE_APP_API_URL + this.$route.path.replace("edit", "log")
        )
        .then((res) => {
          if (res.status == 200) {
            this.listLogsLoading = false;

            const response = res.data;

            if (response) {
              this.listLogs = response;
            }
          }
        })
        .finally(() => {});
    },
    setStatus(status) {
      this.formData.status = status;
    },
    dateformat(date, format = "YYYY-MM-DD HH:mm:ss") {
      return this.moment(date).format(format);
    },
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;

            this.formData = { ...this.formData, ...data };
            this.formData.fee = data.fee ? data.fee.amount : 0;
            this.currentStatus = data.status;

            this.memberBankHistory = data.from_bank_account.history;

            if (data.status == 0) {
              this.formData.status = null;
              this.formData.before_credit = data.account.balance.amount;
            }

            this.bankBalance = data.to_bank_account.balance.amount;
            this.bankLimit = data.to_bank_account.limit;

            if (this.formData.status != 0) {
              this.formData.bank_date = data.bank_transaction.date;
            }

            this.formData.panel_date = data.date;

            // res.data = data.account_transaction_data;

            this.lastDepositData = data.last_withdraw;
            // this.bankTransactionData = data.bank_transaction_data;

            // this.formData = { ...this.formData, ...data };
            // this.formData.panel_date = data.date;
            // this.formData.bank_date =
            //   data.bank_transaction.date;

            // if (!data.bonus) {
            //   this.formData.bonus = 0;
            // }

            // if (data.to_account) {
            //   this.formData.asset = data.to_account.asset;
            //   this.formData.account = data.to_account;

            //   if (data.status != 0) {
            //     this.formData.before_credit = data.before_credit;
            //   } else {
            //     this.formData.before_credit = data.to_account.balance;
            //   }

            this.calculateBalance();

            //   this.getListMemberBank(
            //     this.formData.account.member_id,
            //     data.member_bank
            //   );

            //   this.formData.bank_category = data.bank_account.bank_category;
            //   this.getListBank(this.formData.bank);
            // } else {
            //   this.formData.bank_category = data.bank_account.bank_category;
            //   this.placeholder = true;
            //   this.getListBank(this.formData.bank);
            // }

            this.formReady = true;
          }
        })
        .catch((err) => {
          // console.log(err);
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    getListAccount(query) {
      if (query.length >= 3) {
        this.debounce(() => {
          this.listAccountLoading = true;

          const assetParam = this.formData.asset
            ? "&asset_id=" + this.formData.asset.id
            : "";

          this.$http
            .get(
              process.env.VUE_APP_API_URL +
                "/member-account?search=" +
                query +
                assetParam
            )
            .then((res) => {
              if (res.status == 200) {
                const response = res.data;

                if (response) {
                  this.listAccount = response.data;
                }
              }
            })
            .finally(() => {
              this.listAccountLoading = false;
            });
        }, 500);
      }
    },
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
  },
};
</script>
